import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

// Poll /version.json toutes les VERSION_POLL_MS pour détecter un déploiement
// récent. Si la version reçue diffère de __APP_VERSION__ (embedded à build),
// affiche une bannière de mise à jour. L'app se recharge sur clic OU sur la
// prochaine navigation route (silencieux, no-op si déjà à jour).
const VERSION_POLL_MS = 60_000;

export function VersionWatcher() {
  const [newVersion, setNewVersion] = useState<string | null>(null);

  useEffect(() => {
    let stop = false;
    const check = async () => {
      try {
        const r = await fetch('/version.json', { cache: 'no-store' });
        if (!r.ok) return;
        const { version } = await r.json();
        if (version && version !== __APP_VERSION__) {
          if (!stop) setNewVersion(version);
        }
      } catch { /* offline, retry plus tard */ }
    };
    check();  // immédiat
    const t = setInterval(check, VERSION_POLL_MS);
    // Re-check quand le tab redevient visible (user revient après idle)
    const onVis = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { stop = true; clearInterval(t); document.removeEventListener('visibilitychange', onVis); };
  }, []);

  if (!newVersion) return null;
  return (
    <div className="fixed top-2 right-2 z-50 max-w-sm bg-bg-2 border border-info/40 rounded shadow-xl p-3 flex items-center gap-3">
      <RefreshCw size={14} className="text-info shrink-0" />
      <div className="flex-1 text-xs">
        <div className="font-semibold text-text">Mise à jour disponible</div>
        <div className="text-text-muted">Rechargez pour appliquer les dernières corrections.</div>
      </div>
      <button
        className="btn btn-primary btn-sm"
        onClick={() => window.location.reload()}>
        Recharger
      </button>
    </div>
  );
}
